import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";
import "./../src/assets/scss/main.scss";
import "./custom.scss";

import { Provider } from "react-redux";
import store from "./store";
import history from "./history";
import MainRoutes from "./route/routes";

ReactDOM.render(
  <Provider store={store}>
    <MainRoutes history={history} />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
